export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS";
export const CLEAR_NOSYSTEM_NOTIFICATIONS = "CLEAR_NOSYSTEM_NOTIFICATIONS";
